/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";

import store from './store';

import moment from 'moment';
moment.updateLocale('en',{week:{dow:1}});
Vue.prototype.$moment = moment;

import printJS from 'print-js';
Vue.prototype.$print = printJS

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
Vue.use(PaperDashboard);

import API from './services/api';
Vue.prototype.$api = API;

import Table from 'bootstrap-vue';
Vue.use(Table);

import izitoast from './services/toast'
Vue.prototype.$toast = izitoast

import '@fortawesome/fontawesome-free/css/all.css'

/* eslint-disable */
new Vue({
	store,
  	router,
  	render: h => h(App)
}).$mount("#app");
